import {
  Button,
  Typography,
  Box,
  Paper,
  Container,
  Modal,
  styled,
} from "@mui/material";
import { Navigate, useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { PDFViewer } from "@react-pdf/renderer";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { IconContext } from "react-icons";
import { TfiDownload } from "react-icons/tfi";
import { useAppSelector } from "../../_app";
import { Notify, Utils } from "../../utils";
import { NavLink } from "react-router-dom";
import {
  EmployeeService,
  PayrunService,
  TellBossService,
} from "../../_service";
import { CommonModal, CustomButton, Loader } from "../../components";
import { useEffect, useMemo, useState } from "react";
import PayrunPdf from "../../components/pdfs/PayrunDocuments";
import { CreatePayrunModal } from "../../components";
import FinalizedPayrun from "../../components/payrun/FinalizedPayrun";
import { Constant } from "../../config";
import { Colors } from "../../config/color";
import moment from "moment";
import useFirebaseAnalytics from "../../hooks/useFirebaseAnalytics";
import merge from "lodash.merge";
import { TailSpin } from "react-loader-spinner";
import { da } from "date-fns/locale";
import { microAgent } from "../../newRelicConfig";
import SendToBossModal from "../../components/modals/SendToBossModal";
// convertToDateString

const PayrunItem = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  marginTop: 0,
  padding: "2px 16px",
  backgroundColor: "#ffffff",
  borderRadius: "8px",
  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
  transition: "all 0.3s ease",
  "&:hover": {
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
  },
  [theme.breakpoints.down("lg")]: {
    flexDirection: "column",
    padding: "2px 16px",
  },
}));

const PayslipContainer = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  width: "120px",
  border: "1px solid #e5e7eb",
  borderRadius: "6px",
  overflow: "hidden",
  transition: "transform 0.2s ease",
  "&:hover": {
    transform: "translateY(-2px)",
  },
}));

const Title = styled(Box)(() => ({
  background: "#f3f4f6",
  textAlign: "center",
  padding: "4px 8px",
  fontSize: "14px",
  fontWeight: 500,
  color: "#4b5563",
}));

const Value = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  // height: "2rem",
  fontSize: "1.25rem",
  fontWeight: 600,
  color: "#1f2937",
}));

const Link = styled(Box)(() => ({
  display: "flex",
  padding: "0.25rem 0.5rem",
  justifyContent: "center",
  alignItems: "center",
  // height: "12px",
  fontSize: "14px",
  fontWeight: 500,
  borderTop: "1px solid #e5e7eb",
  color: "#2563eb",
  cursor: "pointer",
  transition: "background-color 0.2s ease",
  "&:hover": {
    backgroundColor: "#f3f4f6",
  },
}));

const PayrunBlock = ({ payrunDate, payrunData, loading, setLoading }: any) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const defaultCompanyId = useAppSelector(
    (state) => +state.user.defaultCompnayId
  );

  // const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>({});
  // const [accountingInfoData, setAccoutingInfoData] = useState<any>({});
  const [open, setOpen] = useState(false);
  const [createModal, setCreateModal] = useState<boolean>(false);
  const [activeDataModal, setActiveDataModal] = useState<string | null>(null);
  const [pdfModal, setPdfModal] = useState<boolean>(false);
  const [pdfViewModal, setPdfViewModal] = useState<boolean>(false);
  const [currentPayrun, setCurrentPayrun] = useState<null | number>(null);
  const [finalizedData, setFinalizedData] = useState<any[]>([]);
  const [isApprovalModalOpen, setIsApprovalModalOpen] = useState(false);
  const [dateToApprove, setDateToApprove] = useState("");

  const [dataView, setDataView] = useState<any[]>([]);
  const companyId = useAppSelector((state) => state.user.defaultCompnayId);
  const companyName = useAppSelector((state) => state.user.defaultCompany);

  const hasViewAccess = useMemo(
    () => Utils.checkAccess("pay_run", "pay_run", "view"),
    []
  );
  const hasAddEditAccess = useMemo(
    () => Utils.checkAccess("pay_run", "pay_run", "add/edit"),
    []
  );

  const user = useAppSelector((state) => state.user);
  const currentPayrunDate = useAppSelector(
    (state) => state.user.current_payrun_date
  );

  const sendForApproval = async () => {
    setLoading(true);
    setIsApprovalModalOpen(() => false);
    const dataToApprove = {
      company: companyId,
      payslip_date: payrunDate,
    };

    try {
      const { status } = await EmployeeService._sendForApproval(dataToApprove);

      if (status >= 200 && status < 300) {
        Notify("Payslips Sent for Approval", 1);
        window.location.reload();
        setLoading(false);
      }
    } catch (error: any) {
      if (error?.response?.data?.paylsip) {
        Notify(error?.response?.data?.paylsip, 0);
      } else {
        Notify(Constant.common.something_went_wrong, 0);
      }
      setLoading(false);
    }
    // setIsApprovalModalOpen(() => false);
    setDateToApprove(() => "");
  };

  const tempData = {
    finalized: [],
    pending: [],
    payrun_in_process: [
      {
        approval_history: {
          id: 702,
          payslip_date: "2025-01-31",
          action_taken: null,
          approval_reversal_count: 0,
          last_approval_reversal_at: null,
          payrun_created_at: null,
          archived: false,
          created_at: "2025-05-16T18:57:46.999730+08:00",
          updated_at: "2025-05-16T18:57:46.999741+08:00",
          company: 34,
          approved_by: null,
          employee_payslips: [2649, 2648, 2646, 2791, 2651, 2647, 2652, 2650],
          approver_name: null,
        },
        payslips: [
          {
            id: 2649,
            payslip_date: "2025-01-31",
            is_finalized: true,
            is_pay_run: false,
            is_sent_for_approval: true,
            is_approved: false,
            payslip_info: {
              income: {
                data: [
                  {
                    code: "basic_salary",
                    name: "Basic Salary",
                    note: "",
                    value: "5,000.00",
                  },
                  {
                    code: "ot_-hr_@_2x",
                    name: "OT -Hr @ 2x",
                    note: "",
                    value: "0.00",
                  },
                ],
                total: "5,000.00",
                percentage_rate: 0,
              },
              net_pay: "4,750.00",
              deductions: {
                data: [
                  {
                    code: "others",
                    name: "Others",
                    note: "",
                    value: "0.00",
                  },
                  {
                    code: "cpf_-_employee",
                    name: "CPF - Employee",
                    note: "",
                    value: "250.00",
                  },
                ],
                total: "250.00",
              },
              cpf_details: {
                aw: "0.00",
                ow: "5000.00",
                cpfb: "425.00",
              },
              payslip_date: {
                end: "2025-01-31",
                start: "2025-01-01",
              },
              employer_contribution: {
                data: [
                  {
                    code: "cpf_-_employer",
                    name: "CPF - Employer",
                    note: "",
                    value: "175.00",
                  },
                ],
                total: "175.00",
              },
            },
            leave_info: {},
            archived: false,
            created_at: "2025-01-10T20:08:17.773328+08:00",
            employee: 310,
            company: 34,
            approved_by: null,
          },
          {
            id: 2648,
            payslip_date: "2025-01-31",
            is_finalized: true,
            is_pay_run: false,
            is_sent_for_approval: true,
            is_approved: false,
            payslip_info: {
              income: {
                data: [
                  {
                    code: "basic_salary",
                    name: "Basic Salary",
                    note: "",
                    value: "3,000.00",
                  },
                ],
                total: "3,000.00",
                percentage_rate: 0,
              },
              net_pay: "2,849.00",
              deductions: {
                data: [
                  {
                    code: "cdac",
                    name: "CDAC",
                    note: "",
                    value: "1.00",
                  },
                  {
                    code: "cpf_-_employee",
                    name: "CPF - Employee",
                    note: "",
                    value: "150.00",
                  },
                ],
                total: "151.00",
              },
              cpf_details: {
                aw: "0.00",
                ow: "3000.00",
                cpfb: "383.50",
              },
              payslip_date: {
                end: "2025-01-31",
                start: "2025-01-01",
              },
              employer_contribution: {
                data: [
                  {
                    code: "sdl",
                    name: "SDL",
                    note: "",
                    value: "7.50",
                  },
                  {
                    code: "cpf_-_employer",
                    name: "CPF - Employer",
                    note: "",
                    value: "225.00",
                  },
                ],
                total: "232.50",
              },
            },
            leave_info: {},
            archived: false,
            created_at: "2025-01-10T20:08:17.575440+08:00",
            employee: 144,
            company: 34,
            approved_by: null,
          },
          {
            id: 2646,
            payslip_date: "2025-01-31",
            is_finalized: true,
            is_pay_run: false,
            is_sent_for_approval: true,
            is_approved: false,
            payslip_info: {
              income: {
                data: [
                  {
                    code: "basic_salary",
                    name: "Basic Salary",
                    note: "",
                    value: "8,000.00",
                  },
                  {
                    code: "monthly_commission",
                    name: "Monthly Commission",
                    note: "",
                    value: "0.00",
                  },
                  {
                    code: "ot_-hr_@_1.5x",
                    name: "OT -Hr @ 1.5x",
                    note: "",
                    value: "0.00",
                  },
                  {
                    code: "ot_hr_@_1x",
                    name: "OT Hr @ 1X",
                    note: "",
                    value: "0.00",
                  },
                ],
                total: "8,000.00",
                percentage_rate: 0,
              },
              net_pay: "6,522.00",
              deductions: {
                data: [
                  {
                    code: "mbmf",
                    name: "MBMF",
                    note: "",
                    value: "9.00",
                  },
                  {
                    code: "sinda",
                    name: "SINDA",
                    note: "",
                    value: "9.00",
                  },
                  {
                    code: "employer_loan",
                    name: "Loan Repayment",
                    note: "",
                    value: "200.00",
                  },
                  {
                    code: "cpf_-_employee",
                    name: "CPF - Employee",
                    note: "",
                    value: "1,260.00",
                  },
                ],
                total: "1,478.00",
              },
              cpf_details: {
                aw: "0.00",
                ow: "8000.00",
                cpfb: "2,360.25",
              },
              payslip_date: {
                end: "2025-01-31",
                start: "2025-01-01",
              },
              employer_contribution: {
                data: [
                  {
                    code: "sdl",
                    name: "SDL",
                    note: "",
                    value: "11.25",
                  },
                  {
                    code: "cpf_-_employer",
                    name: "CPF - Employer",
                    note: "",
                    value: "1,071.00",
                  },
                ],
                total: "1,082.25",
              },
            },
            leave_info: {},
            archived: false,
            created_at: "2025-01-10T20:08:17.234576+08:00",
            employee: 152,
            company: 34,
            approved_by: null,
          },
          {
            id: 2791,
            payslip_date: "2025-01-31",
            is_finalized: true,
            is_pay_run: false,
            is_sent_for_approval: true,
            is_approved: false,
            payslip_info: {
              income: {
                data: [
                  {
                    code: "basic_salary",
                    name: "Basic Salary",
                    note: "",
                    value: "100.00",
                  },
                ],
                total: "100.00",
                percentage_rate: 0,
              },
              net_pay: "98.00",
              deductions: {
                data: [
                  {
                    code: "ecf",
                    name: "ECF",
                    note: "",
                    value: "2.00",
                  },
                  {
                    code: "cpf_-_employee",
                    name: "CPF - Employee",
                    note: "",
                    value: "0.00",
                  },
                ],
                total: "2.00",
              },
              cpf_details: {
                aw: "0.00",
                ow: "100.00",
                cpfb: "21.00",
              },
              payslip_date: {
                end: "2025-01-31",
                start: "2025-01-01",
              },
              employer_contribution: {
                data: [
                  {
                    code: "sdl",
                    name: "SDL",
                    note: "",
                    value: "2.00",
                  },
                  {
                    code: "cpf_-_employer",
                    name: "CPF - Employer",
                    note: "",
                    value: "17.00",
                  },
                ],
                total: "19.00",
              },
            },
            leave_info: {},
            archived: false,
            created_at: "2025-03-17T15:26:25.016835+08:00",
            employee: 220,
            company: 34,
            approved_by: null,
          },
          {
            id: 2651,
            payslip_date: "2025-01-31",
            is_finalized: true,
            is_pay_run: false,
            is_sent_for_approval: true,
            is_approved: false,
            payslip_info: {
              income: {
                data: [
                  {
                    code: "basic_salary",
                    name: "Basic Salary",
                    note: "",
                    value: "2,850.00",
                  },
                  {
                    code: "ot_-hr_@_1.5x",
                    name: "OT -Hr @ 1.5x",
                    note: "",
                    value: "0.00",
                  },
                ],
                total: "2,850.00",
                percentage_rate: 0,
              },
              net_pay: "2,279.00",
              deductions: {
                data: [
                  {
                    code: "cdac",
                    name: "CDAC",
                    note: "",
                    value: "1.00",
                  },
                  {
                    code: "cpf_-_employee",
                    name: "CPF - Employee",
                    note: "",
                    value: "570.00",
                  },
                ],
                total: "571.00",
              },
              cpf_details: {
                aw: "0.00",
                ow: "2850.00",
                cpfb: "1,063.12",
              },
              payslip_date: {
                end: "2025-01-31",
                start: "2025-01-01",
              },
              employer_contribution: {
                data: [
                  {
                    code: "sdl",
                    name: "SDL",
                    note: "",
                    value: "7.12",
                  },
                  {
                    code: "cpf_-_employer",
                    name: "CPF - Employer",
                    note: "",
                    value: "485.00",
                  },
                ],
                total: "492.12",
              },
            },
            leave_info: {},
            archived: false,
            created_at: "2025-01-10T20:08:18.109930+08:00",
            employee: 145,
            company: 34,
            approved_by: null,
          },
          {
            id: 2647,
            payslip_date: "2025-01-31",
            is_finalized: true,
            is_pay_run: false,
            is_sent_for_approval: true,
            is_approved: false,
            payslip_info: {
              income: {
                data: [
                  {
                    code: "basic_salary",
                    name: "Basic Salary",
                    note: "",
                    value: "2,000.00",
                  },
                ],
                total: "2,000.00",
                percentage_rate: 0,
              },
              net_pay: "1,900.00",
              deductions: {
                data: [
                  {
                    code: "employer_loan",
                    name: "Loan Repayment",
                    note: "",
                    value: "100.00",
                  },
                  {
                    code: "cpf_-_employee",
                    name: "CPF - Employee",
                    note: "",
                    value: "0.00",
                  },
                ],
                total: "100.00",
              },
              cpf_details: {
                aw: "0.00",
                ow: "2000.00",
                cpfb: "5.00",
              },
              payslip_date: {
                end: "2025-01-31",
                start: "2025-01-01",
              },
              employer_contribution: {
                data: [
                  {
                    code: "sdl",
                    name: "SDL",
                    note: "",
                    value: "5.00",
                  },
                  {
                    code: "cpf_-_employer",
                    name: "CPF - Employer",
                    note: "",
                    value: "0.00",
                  },
                ],
                total: "5.00",
              },
            },
            leave_info: {},
            archived: false,
            created_at: "2025-01-10T20:08:17.413929+08:00",
            employee: 140,
            company: 34,
            approved_by: null,
          },
          {
            id: 2652,
            payslip_date: "2025-01-31",
            is_finalized: true,
            is_pay_run: false,
            is_sent_for_approval: true,
            is_approved: false,
            payslip_info: {
              income: {
                data: [
                  {
                    code: "basic_salary",
                    name: "Basic Salary",
                    note: "",
                    value: "8,000.00",
                  },
                ],
                total: "8,000.00",
                percentage_rate: 0,
              },
              net_pay: "6,727.00",
              deductions: {
                data: [
                  {
                    code: "cdac",
                    name: "CDAC",
                    note: "",
                    value: "3.00",
                  },
                  {
                    code: "savings",
                    name: "Savings Deduction",
                    note: "",
                    value: "10.00",
                  },
                  {
                    code: "cpf_-_employee",
                    name: "CPF - Employee",
                    note: "",
                    value: "1,260.00",
                  },
                ],
                total: "1,273.00",
              },
              cpf_details: {
                aw: "0.00",
                ow: "8000.00",
                cpfb: "2,345.25",
              },
              payslip_date: {
                end: "2025-01-31",
                start: "2025-01-01",
              },
              employer_contribution: {
                data: [
                  {
                    code: "sdl",
                    name: "SDL",
                    note: "",
                    value: "11.25",
                  },
                  {
                    code: "cpf_-_employer",
                    name: "CPF - Employer",
                    note: "",
                    value: "1,071.00",
                  },
                ],
                total: "1,082.25",
              },
            },
            leave_info: {},
            archived: false,
            created_at: "2025-01-10T20:08:18.314869+08:00",
            employee: 147,
            company: 34,
            approved_by: null,
          },
          {
            id: 2650,
            payslip_date: "2025-01-31",
            is_finalized: true,
            is_pay_run: false,
            is_sent_for_approval: true,
            is_approved: false,
            payslip_info: {
              income: {
                data: [
                  {
                    code: "basic_salary",
                    name: "Basic Salary",
                    note: "",
                    value: "8,200.00",
                  },
                ],
                total: "8,200.00",
                percentage_rate: 0,
              },
              net_pay: "7,231.00",
              deductions: {
                data: [
                  {
                    code: "mbmf",
                    name: "MBMF",
                    note: "",
                    value: "24.00",
                  },
                  {
                    code: "cpf_-_employee",
                    name: "CPF - Employee",
                    note: "",
                    value: "945.00",
                  },
                ],
                total: "969.00",
              },
              cpf_details: {
                aw: "0.00",
                ow: "8200.00",
                cpfb: "1,894.25",
              },
              payslip_date: {
                end: "2025-01-31",
                start: "2025-01-01",
              },
              employer_contribution: {
                data: [
                  {
                    code: "sdl",
                    name: "SDL",
                    note: "",
                    value: "11.25",
                  },
                  {
                    code: "cpf_-_employer",
                    name: "CPF - Employer",
                    note: "",
                    value: "914.00",
                  },
                ],
                total: "925.25",
              },
            },
            leave_info: {},
            archived: false,
            created_at: "2025-01-10T20:08:17.931348+08:00",
            employee: 146,
            company: 34,
            approved_by: null,
          },
        ],
        is_payrun_ready: false,
      },
    ],
  };

  const handleViewAndPreView = (data: any) => {
    console.log("handleView data", data);
    setDataView(() => data);
    setPdfViewModal(() => true);
  };

  const handleOpenModal = (data: any[]) => {
    setFinalizedData(() => data);
    setOpen(true);
  };

  const handleUnFinalisation = async () => {
    setLoading(true);
    setOpen(false);
    try {
      const ids = finalizedData?.map((_) => _.id);
      const formData = new FormData();
      formData.append("finalize", "false");
      formData.append("payslip_ids", ids.join(","));
      formData.append("company", `${companyId}`);
      const res = await PayrunService._bulkPayslipFinalize(formData);
      // setOpen(false);

      if (res.status >= 200 && res.status < 300) {
        // firebase log here
        let key = "unfinalize";
        let data = {
          user_id: user.id,
          name: user.name,
          // device_fingerprint: "using_client_js",
          event_date_time: moment().utc().format("DD/MM/YYYY hh:mm A"),
          platform: "web",
        };
        // logFirebaseEvent(key, data);
        microAgent.addPageAction(key, data);

        setData({});
      }

      // instead of calling get() here, just updating the year to currentYear to fetch the currenty year data
      // setYear(currentPayrunDate?.split("-")?.[0]);
      window.location.reload();
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  console.log("Payrun Data", payrunData, {
    "total pending": payrunData?.pending?.length,
    "total finalized": payrunData?.finalized?.length,
    "total payrun in process": payrunData?.payrun_in_process?.length,
  });

  console.log("isApprovalModal", isApprovalModalOpen);

  return (
    <div>
      {/* First block - Show if pending or finalized payslips exist */}
      {(payrunData?.pending?.length > 0 ||
        payrunData?.finalized?.length > 0) && (
        <div
          style={{
            padding: "0.5rem",
            // marginTop: "0.5rem",
          }}
        >
          <PayrunItem>
            <div>
              {/* <Typography variant="h6" component="h5">
                The month ending {Utils.convertToDateString(payrunDate)}
              </Typography> */}
              <Typography variant="h6" component="h5" sx={{fontSize: '1rem'}}>
                Pay Run: Monthly - {payrunDate}
              </Typography>

              {payrunData?.finalized?.length >= 0 && (
                <Box sx={{ mt: 0, p: 1, px:0, bgcolor: '#f8f9fa', borderRadius: 2, border: '1px solid #e9ecef' }}>
                  {/* <Typography variant="h6" sx={{ mb: 3, color: '#2c3e50', fontWeight: 600 }}>
                    Pay Run Process
                  </Typography> */}
                  
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                    {/* Step 1 */}
                    <Box sx={{  display: 'flex', flexDirection: 'column', gap: 0.5, flex: 1  }}>
                      
                      <Typography sx={{ color: '#6c757d', fontWeight: 500, marginLeft: 1.25, fontSize: "0.875rem", padding: "0" }}>
                        Step 1 - "Pay Runs" menu - Admin to click HERE to send "Finised" payslips to TellBoss App for Approval
                      </Typography>

                       {payrunData?.finalized?.length > 0 && <Button
                          onClick={() => {
                            setIsApprovalModalOpen(() => true);
                          }}
                          variant="contained"
                          disabled={loading}
                          sx={{
                            bgcolor: '#03b381',
                            color: 'white',
                            textTransform: 'uppercase',
                            fontWeight: 500,
                            // py: 1,
                            // px: 1.25,
                            p:0,
                            px: 1,
                            borderRadius: 1,
                            boxShadow: '0 2px 4px rgba(3, 179, 129, 0.2)',
                            '&:hover': {
                              bgcolor: '#028a6a',
                              boxShadow: '0 4px 8px rgba(3, 179, 129, 0.3)',
                            },
                            '&:disabled': {
                              bgcolor: '#e9ecef',
                              color: '#6c757d',
                            },
                            maxWidth: 'fit-content',
                          }}
                        >
                          {loading ? (
                            <TailSpin color="#ffffff" height={20} width={20} />
                          ) : (
                            '"Pay Runs" menu - Admin to click HERE to send "Finised" payslips to TellBoss App for Approval'
                          )}
                        </Button>}
                    </Box>

                    {/* Step 2 */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2,  }}>
                      
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, flex: 1 }}>
                        <Typography variant="subtitle1" sx={{ color: '#6c757d', fontWeight: 500, marginLeft: 1.25, fontSize: "0.875rem" }}>
                          Step 2 - Go to "Payroll-TellBoss" menu to receive TellBoss approval OR Admin to approve
                        </Typography>
                       
                      </Box>
                    </Box>

                    {/* Step 3 */}
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                     
                      <Typography variant="subtitle1" sx={{ color: '#6c757d', fontWeight: 500, marginLeft: 1.25, fontSize: "0.875rem" }}>
                        Step3 - "Pay Runs" menu - After received approval, click "Create PayRun" button
                      </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                     
                      <Typography variant="subtitle1" sx={{ color: '#6c757d', fontWeight: 500, marginLeft: 1.25, fontSize: "0.875rem" }}>
                        Step 4 - "Manage Employees" menu - Go and finalise more payslips and repeat Step 1 again
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              )}
            </div>

            {/* Counter Boxes */}

            <Box
              sx={{
                ml: "0.75rem",
                mr: "1rem",
                [theme.breakpoints.down("lg")]: {
                  // mt: "8px",
                },
              }}
            >
              <p>Payslips</p>
              <Box mt={2} sx={{ display: "flex" }}>
                <PayslipContainer mr={2}>
                  <Title>Total</Title>
                  <Value>
                    {payrunData?.finalized?.length +
                      payrunData?.pending?.length}
                  </Value>
                </PayslipContainer>
                <PayslipContainer mr={2}>
                  <Title>Finished</Title>
                  <Value>{payrunData?.finalized?.length}</Value>
                  {/* view finalised payruns */}
                  {hasViewAccess && payrunData?.finalized?.length > 0 && (
                    <>
                      <Link key={payrunDate}>
                        <p
                          style={{
                            fontSize: "1rem",
                            color: "#059bbf",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleViewAndPreView(payrunData?.finalized);
                          }}
                        >
                          View
                        </p>
                      </Link>
                      {hasAddEditAccess && (
                        <Link>
                          <p
                            style={{
                              fontSize: "1rem",
                              color: "#059bbf",
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              handleOpenModal(payrunData?.finalized)
                            }
                          >
                            UnFinalise
                          </p>
                        </Link>
                      )}
                    </>
                  )}
                </PayslipContainer>
                <PayslipContainer>
                  <Title>Pending</Title>
                  <Value>{payrunData?.pending?.length}</Value>

                  {/* prevview pending payrun */}
                  {pdfModal && currentPayrun === payrunDate && (
                    <Modal open={pdfModal} onClose={() => setPdfModal(false)}>
                      <Paper
                        sx={{
                          width: "100%",
                          height: "100%",
                          background: "white",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          position: "relative",
                        }}
                      >
                        <Box
                          className="close-icon"
                          sx={{
                            position: "absolute",
                            top: 20,
                            right: 20,
                          }}
                          onClick={() => setPdfModal(false)}
                        >
                          <IconContext.Provider
                            value={{ color: "#f00", size: "30px" }}
                          >
                            <AiOutlineCloseCircle />
                          </IconContext.Provider>
                        </Box>
                        <PDFViewer width="90%" height="90%">
                          <PayrunPdf
                            documents={payrunData?.pending}
                            payslipSettings={user?.payslip_settings}
                          />
                        </PDFViewer>
                      </Paper>
                    </Modal>
                  )}

                  {/* view finalized payrun */}
                  {pdfViewModal && (
                    <Modal
                      open={pdfViewModal}
                      onClose={() => setPdfViewModal(() => false)}
                    >
                      <Paper
                        sx={{
                          width: "100%",
                          height: "100%",
                          background: "white",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          position: "relative",
                        }}
                      >
                        <Box
                          className="close-icon"
                          sx={{
                            position: "absolute",
                            top: 20,
                            right: 20,
                          }}
                          onClick={() => setPdfViewModal(() => false)}
                        >
                          <IconContext.Provider
                            value={{ color: "#f00", size: "30px" }}
                          >
                            <AiOutlineCloseCircle />
                          </IconContext.Provider>
                        </Box>
                        <PDFViewer width="90%" height="90%">
                          <PayrunPdf
                            documents={dataView || {}}
                            finalized={true}
                            payslipSettings={user?.payslip_settings}
                          />
                        </PDFViewer>
                      </Paper>
                    </Modal>
                  )}
                  {hasViewAccess && payrunData?.pending?.length > 0 && (
                    <>
                      <Link>
                        <p
                          style={{
                            fontSize: "1rem",
                            color: "#059bbf",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setPdfModal(true);
                            setCurrentPayrun(payrunDate);
                          }}
                        >
                          Preview
                        </p>
                      </Link>
                      {hasAddEditAccess && (
                        <Link>
                          <NavLink
                            to="/dashboard/bulk_finalisation"
                            state={{
                              data: payrunData?.pending,
                              date: payrunDate,
                            }}
                            style={{
                              fontSize: "1rem",
                              color: "#059bbf",
                              cursor: "pointer",
                              textDecoration: "none",
                            }}
                          >
                            Finalise
                          </NavLink>
                        </Link>
                      )}
                    </>
                  )}
                </PayslipContainer>
              </Box>
            </Box>

            <CommonModal
              handleClose={() => {
                setOpen(false);
              }}
              open={open}
              updateData={handleUnFinalisation}
              body={`${finalizedData?.length} payslip(s) will be unfinalised in bulk. Please only use
              this option if you need to change the majority of your payslips for
              the current period. If you are at all uncertain, we would
              strongly advise that you unfinalise payslips individually to prevent
              any unexpected changes. Are you sure you want to continue?`}
              loading={loading}
            />

            <SendToBossModal
              open={isApprovalModalOpen}
              handleClose={() => setIsApprovalModalOpen(false)}
              onConfirm={() => {
                // Handle confirmation logic here
                sendForApproval();
                console.log("Confirmed");
                setIsApprovalModalOpen(false);
              }}
              loading={loading}
              pendingPayslipsCount={payrunData?.pending?.length || 0}
              payrunDate={payrunDate}
            />

            {/* <CommonModal
              handleClose={() => setIsApprovalModalOpen(() => false)}
              open={isApprovalModalOpen}
              updateData={sendForApproval}
              body={`If Admin has finalized all the payslips then click "Confirm" icon`}
              heading={`Click "Confirm" to send payroll to "TellBoss" app`}
              conformButtonText="Confirm"
              cancelButtonText="Stop - Go to finalize payslips"
              loading={loading}
            /> */}
          </PayrunItem>
        </div>
      )}

      {/* Second block - Show if payrun in process exists */}
      {payrunData?.payrun_in_process?.map((processItem: any, index: number) => (
        <div key={index} style={{ padding: "0.5rem" }}>
          <PayrunItem>
            <div>
              {/* <Typography variant="h6" component="h5">
                The month ending {Utils.convertToDateString(payrunDate)}
              </Typography> */}
              <Typography variant="h6" component="h5">
                Pay Run: Monthly - {payrunDate}
              </Typography>

              {/* Received the approval */}
              {processItem?.is_payrun_ready && (
                <p
                  style={{
                    color: "#03b381",
                    marginTop: 15,
                    marginBottom: 15,
                    fontSize: "1.35rem",
                    fontWeight: 600,
                    outline: "black",
                  }}
                >
                  <em>
                    Received approval on{" "}
                    {/* {Utils._dateToShow(
                  payrun[1]?.finalized[0]?.updated_at
                )} */}
                    {moment(
                      processItem?.approval_history?.approval_date ||
                        processItem?.approval_history?.updated_at
                    ).format("DD/MM/YYYY hh:mm A")}{" "}
                    by {`${processItem?.approval_history?.approver_name || ""}`}
                  </em>
                </p>
              )}

              {/* Received the approval,  show create payrun button */}
              {processItem?.is_payrun_ready && (
                <CustomButton
                  title="Create PayRun"
                  styles={{
                    // width: 740,
                    height: 40,
                    fontWeight: 600,
                    padding: 12,
                    margin: 32,
                    marginLeft: 0,
                  }}
                  onClick={() => {
                    setCreateModal(true);
                    setActiveDataModal(payrunDate);
                  }}
                />
              )}

              {/* Create Payrun Modal */}
              {createModal && (
                <CreatePayrunModal
                  open={createModal}
                  approvalHistoryId={processItem?.approval_history?.id}
                  handleClose={() => {
                    setCreateModal(() => false);
                  }}
                  date={payrunDate}
                  pendingCount={0}
                  companyId={parseInt(companyId)}
                  // clearPreviousState={() => setData({})}
                  clearPreviousState={() => window.location.reload()}
                />
              )}

              {/* Already sent to tellboss for approval */}
              {!processItem?.is_payrun_ready && (
                <div
                  style={{
                    marginTop: "0.875rem",
                    background: "#ff6665",
                    color: "#ffffff",
                    padding: "0.625rem 1rem",
                    borderRadius: "0.25rem",
                    height: "fit-content",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "1rem",
                    marginRight: "auto",
                    width: "fit-content",
                  }}
                >
                  <p style={{ margin: 0, fontWeight: 600 }}>
                    Already sent Finalized Payroll to TellBoss app for first
                    approval
                  </p>
                </div>
              )}
            </div>

            {/* Counter Boxes */}

            <Box
              sx={{
                ml: "0.75rem",
                mr: "1rem",
                [theme.breakpoints.down("lg")]: {
                  mt: "8px",
                },
              }}
            >
              <p>Payslips</p>
              <Box mt={1} sx={{ display: "flex" }}>
                <PayslipContainer mr={2}>
                  <Title>Total</Title>
                  <Value>{processItem.payslips?.length || 0}</Value>
                </PayslipContainer>
                <PayslipContainer mr={2}>
                  <Title>Finished</Title>
                  <Value>{processItem.payslips?.length || 0}</Value>

                  {hasViewAccess && processItem.payslips?.length > 0 && (
                    <Link key={processItem.approval_history.payslip_date}>
                      <p
                        style={{
                          fontSize: "0.875rem",
                          color: "#059bbf",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleViewAndPreView(processItem.payslips);
                        }}
                      >
                        View
                      </p>
                    </Link>
                  )}
                </PayslipContainer>
                <PayslipContainer>
                  <Title>Pending</Title>
                  <Value>{0}</Value>
                </PayslipContainer>
              </Box>
            </Box>
          </PayrunItem>
        </div>
      ))}

      {/* Show "No Records Found" only if both conditions are false */}
      {!payrunData?.pending?.length &&
        !payrunData?.finalized?.length &&
        !payrunData?.payrun_in_process?.length && (
          <div>{"No Records Found"}</div>
        )}
    </div>
  );
};

export default PayrunBlock;
